import React from 'react'
import PropTypes from 'prop-types'
import withReduxProvider from 'components/hocs/withReduxProvider'
import { AdvertiserDisclosure } from 'components/advertiser-disclosure'
import WidgetPage from 'components/hocs/widget-page'
import FullRateTableApp from './full-table/App'
import ShortenedRateTableApp from './shortened-table'

const RateTableApp = props => {
  const { theme, variation } = props,
    isFullTable = variation !== 'shortened',
    showDisclosure = ['fox', 'thebalance1', 'investopedia1'].includes(theme)

  return (
    <>
      { showDisclosure && <AdvertiserDisclosure tooltipId="fox-disclosure" theme={theme} /> }
      {isFullTable
        ? <FullRateTableApp {...props} theme={theme} />
        : <ShortenedRateTableApp {...props} theme={theme} />}
    </>
  )
}

RateTableApp.propTypes = {
  theme: PropTypes.string,
  variation: PropTypes.string,
  experiments: PropTypes.shape({
    activate: PropTypes.func,
    variationMap: PropTypes.object,
    defaultVariationMap: PropTypes.object,
    staticBuild: PropTypes.bool,
  }),
}

// Export named class and functions for unit tests
export { RateTableApp }

export default WidgetPage(withReduxProvider(RateTableApp))
